import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService } from '@oa/shared-core';

@Injectable()
export class GeometryService {
  private readonly _componentName = 'GeometryService';
  
  constructor(private appSetting: AppSettingsService, private http: HttpClient) {}

  /**
   * Gets an object for projecting geometry from WGS84 (4326) to Web Mercator (3857)
   */
  public getWGS84ToWebMercatorFeatureProjection() {
    return {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857',
    };
  }

  /**
   * Gets a geohash value (using the Outdoor Access Piebald API Geometry Endpoint)
   * @param lon
   * @param lat
   * @param precision
   * @returns
   */
  public getGeohash(lon: number, lat: number, precision: number) {
    const url = `${this.appSetting.outdoorAccessPiebaldApiUrl}/Geometry/geohash/${lon}/${lat}/${precision}`;

    return this.http.get<string>(url);
  }
}
